/* ELLESANTI · tema V3 · sezioni del racconto (homepage e pagine), dal prototipo V8. Nessuna libreria. CTRL+G · 29/09/2026.
   Apertura (la foto si posa, i testi salgono, il punto sul gioiello segue l'inquadratura), sei momenti (il segno si ridisegna),
   metodo (video solo sullo schermo e con pausa, frase che si accende lettera per lettera, linea che si disegna), regali (la foto cambia
   con la frase), recensioni (trattini), Instagram (trascinamento). Con il movimento ridotto tutto è già nello stato finale. */
(function () {
  'use strict';
  var H = document.documentElement;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var clamp = function (x, a, b) { a = a === undefined ? 0 : a; b = b === undefined ? 1 : b; return Math.min(b, Math.max(a, x)); };
  var ANIM = H.classList.contains('e-anim');
  var mqDesk = window.matchMedia ? window.matchMedia('(min-width: 1024px)') : { matches: true };
  var redraw = function (s) { if (!s) return; s.classList.remove('is-drawn'); void s.getBoundingClientRect(); s.classList.add('is-drawn'); };

  /* ---------------------------------------------------------------- apertura */
  var HEROES = [];
  /* il punto: X e Y sono percentuali sulla foto intera; qui diventano pixel secondo il ritaglio (object-fit: cover) e l'inquadratura.
     Sul mobile compare solo se attivo (data-m) e mai sotto i testi della foto. Nell'editor mostra i suoi valori e un clic dice dove metterlo. */
  var ED = !!(window.Shopify && window.Shopify.designMode);
  function heroGeo(h) {
    var img = h._img;
    if (!img || !img.naturalWidth) return null;
    var bw = h.clientWidth, bh = h.clientHeight, iw = img.naturalWidth, ih = img.naturalHeight;
    var s = Math.max(bw / iw, bh / ih), dw = iw * s, dh = ih * s;
    var pos = getComputedStyle(img).objectPosition.split(' ');
    var px = parseFloat(pos[0]) / 100, py = parseFloat(pos[1] || pos[0]) / 100;
    if (isNaN(px)) px = 0.5; if (isNaN(py)) py = 0.5;
    return { bw: bw, bh: bh, dw: dw, dh: dh, ox: (bw - dw) * px, oy: (bh - dh) * py };
  }
  function placeHot(h) {
    var hot = h._hot;
    if (!hot) return;
    var desk = mqDesk.matches, on = hot.getAttribute(desk ? 'data-d' : 'data-m') === '1', g = heroGeo(h);
    if (!on || !g) { hot.classList.remove('is-on'); return; }
    var num = function (a, d) { var v = parseFloat(hot.getAttribute(a)); return isNaN(v) ? d : v; };
    var X = desk ? num('data-x', 50) : num('data-xm', 50), Y = desk ? num('data-y', 40) : num('data-ym', 40);
    var x = g.ox + g.dw * X / 100, y = g.oy + g.dh * Y / 100;
    var ok = x > 20 && x < g.bw - 20 && y > (desk ? 90 : 16) && y < g.bh - 20;
    var col = $('.e-hero__col', h), sotto = false;
    if (col) {
      var hr = h.getBoundingClientRect(), cr = col.getBoundingClientRect();
      sotto = x > cr.left - hr.left - 14 && x < cr.right - hr.left + 14 && y > cr.top - hr.top - 14 && y < cr.bottom - hr.top + 14;
    }
    hot.style.left = x.toFixed(1) + 'px';
    hot.style.top = y.toFixed(1) + 'px';
    hot.classList.toggle('is-on', (ok && !sotto) || ED);
    hot.classList.toggle('is-left', x > g.bw * 0.62);
    if (ED) {
      var tag = hot._ed || (hot._ed = hot.appendChild(document.createElement('span')));
      tag.className = 'e-hot__ed';
      tag.textContent = (desk ? '' : 'Mobile · ') + 'X ' + Math.round(X) + ' · Y ' + Math.round(Y) + (!ok ? ' · fuori dalla foto' : (sotto ? ' · sotto i testi: sul sito non si vede' : ''));
      hot.classList.toggle('is-warn', !ok || sotto);
    }
  }
  /* editor: clic sulla foto → dove andrebbe il punto e i valori da scrivere nelle impostazioni */
  function heroProbe(h, e) {
    if (!ED || (e.target.closest && e.target.closest('a,button,input,select,textarea'))) return;
    var g = heroGeo(h); if (!g) return;
    var r = h.getBoundingClientRect(), x = e.clientX - r.left, y = e.clientY - r.top;
    var X = clamp((x - g.ox) / g.dw) * 100, Y = clamp((y - g.oy) / g.dh) * 100;
    var pr = h._probe;
    if (!pr) { pr = h._probe = document.createElement('span'); pr.className = 'e-hot-probe'; pr.setAttribute('aria-hidden', 'true'); h.appendChild(pr); }
    var desk = mqDesk.matches;
    pr.style.left = x.toFixed(1) + 'px';
    pr.style.top = y.toFixed(1) + 'px';
    pr.innerHTML = '<i></i><span><b>X ' + Math.round(X) + ' · Y ' + Math.round(Y) + '</b><br>' + (desk ? 'Scrivili in «Punto · X» e «Punto · Y».' : (h._hot && h._hot.hasAttribute('data-foto-m') ? 'Scrivili in «Punto mobile · X» e «Punto mobile · Y».' : 'Stessa foto del desktop: scrivili in «Punto · X» e «Punto · Y».')) + '</span>';
    pr.classList.toggle('is-left', x > g.bw * 0.62);
  }
  function initHero(scope) {
    $$('[data-e-hero]', scope).forEach(function (h) {
      if (h._e) return;
      h._e = true;
      h._img = $('.e-hero__img', h);
      h._hot = $('[data-e-hot]', h);
      HEROES.push(h);
      var go = function () { requestAnimationFrame(function () { requestAnimationFrame(function () { h.classList.add('is-in'); placeHot(h); }); }); };
      var img = h._img;
      if (!img || img.tagName !== 'IMG' || img.complete) go();
      else { img.addEventListener('load', go, { once: true }); img.addEventListener('error', go, { once: true }); setTimeout(go, 1600); }
      if (img && img.tagName === 'IMG') img.addEventListener('load', function () { placeHot(h); });
      if (ED) { h.classList.add('e-hero--ed'); h.addEventListener('click', function (e) { heroProbe(h, e); }); }
    });
  }
  window.addEventListener('resize', function () { HEROES.forEach(function (h) { if (h.isConnected) placeHot(h); }); });
  if (mqDesk.addEventListener) mqDesk.addEventListener('change', function () { HEROES.forEach(function (h) { if (h.isConnected) placeHot(h); }); });

  /* i link che scorrono a una sezione della pagina (data-e-scroll) sono in v3-ellesanti.js */

  /* ---------------------------------------------------------------- sei momenti: la colonna si accende, il segno si ridisegna */
  function initMomenti(scope) {
    $$('.e-mc', scope).forEach(function (c) {
      if (c._e) return;
      c._e = true;
      var f = function () { redraw($('.e-segno', c)); };
      c.addEventListener('mouseenter', f);
      c.addEventListener('focus', f);
    });
  }

  /* ---------------------------------------------------------------- metodo */
  var METS = [], LNS = [];
  function splitBig(p) {
    if (p._split) return;
    p._split = true;
    var txt = p.textContent.replace(/\s+/g, ' ').trim(), out = [];
    txt.split(' ').forEach(function (w) {
      var ws = document.createElement('span');
      ws.className = 'e-wd';
      ws.setAttribute('aria-hidden', 'true');
      Array.from(w).forEach(function (ch) { var c = document.createElement('span'); c.className = 'e-ch'; c.textContent = ch; ws.appendChild(c); });
      out.push(ws);
    });
    p.textContent = '';
    out.forEach(function (ws, i) { if (i) p.appendChild(document.createTextNode(' ')); p.appendChild(ws); });
    p._chs = $$('.e-ch', p);
  }
  function setBig(p, k) {
    var chs = p._chs || [], N = chs.length, soft = 7, pos = k * (N + soft);
    for (var i = 0; i < N; i++) {
      var a = clamp((pos - i) / soft);
      chs[i].style.opacity = (0.15 + 0.85 * a).toFixed(3);
      chs[i].style.transform = a < 1 ? 'translateY(' + ((1 - a) * 8).toFixed(1) + 'px)' : 'none';
    }
  }
  function setLn(L, R) {
    var d = clamp(R / 0.62);
    if (L.draw) L.draw.style.strokeDashoffset = (1 - d).toFixed(4);
    L.parts.forEach(function (el) { el.classList.toggle('is-on', R > 0.001 && d >= +el.getAttribute('data-f') - 0.0005); });
    var ie = clamp((R - 0.62) / 0.14);
    if (L.inm) L.inm.style.strokeDashoffset = (1 - ie).toFixed(4);
    L.inT.forEach(function (el) { el.classList.toggle('is-on', ie > 0.5); });
    var rr = clamp((R - 0.74) / 0.14);
    if (L.ret) L.ret.style.strokeDashoffset = (1 - rr).toFixed(4);
    L.retT.forEach(function (el) { el.classList.toggle('is-on', rr > 0.6); });
    L.c.forEach(function (el) { el.classList.toggle('is-on', R > 0.9); });
  }
  /* linea verticale (mobile): «una forma che esiste già» parte subito dopo la parola del suo passo, qualunque sia la sua lunghezza */
  function placeIn(L) {
    L.inn.forEach(function (inn) {
      var li = inn.closest('.e-vl__i'), l = li && $('.e-vl__l', li);
      if (!l || !li.offsetWidth) return;
      var rg = document.createRange();
      rg.selectNodeContents(l);
      inn.style.left = Math.round(rg.getBoundingClientRect().right - li.getBoundingClientRect().left + 14) + 'px';
    });
  }
  function initMetodo(scope) {
    $$('[data-e-linea]', scope).forEach(function (w) {
      if (w._e) return;
      w._e = true;
      var L = { w: w, m: w.hasAttribute('data-m'), draw: $('.e-rg-draw', w), inm: $('.e-rg-in-m', w), ret: $('.e-rg-ret', w),
        parts: $$('[data-f]', w), inT: $$('.e-rg-in-t', w), retT: $$('.e-rg-ret-t', w), c: $$('.e-ln__c', w), inn: $$('.e-vl__in', w) };
      LNS.push(L);
      placeIn(L);
      if (!ANIM) setLn(L, 1);
    });
    $$('[data-e-metodo]', scope).forEach(function (m) {
      if (m._e) return;
      m._e = true;
      var big = $('[data-e-big]', m);
      if (big && ANIM) splitBig(big);
      m._big = big;
      METS.push(m);
      var v = $('video[data-e-video]', m), btn = $('[data-e-vctl]', m);
      if (!v) return;
      if (!ANIM) { if (btn) btn.hidden = true; return; }
      var play = function () {
        if (v.dataset.stopped) return;
        if (v.preload === 'none') { v.preload = 'auto'; v.load(); }
        var pr = v.play();
        if (pr && pr.then) pr.then(function () { m.classList.add('is-playing'); }).catch(function () {});
      };
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) play(); else v.pause(); }); }, { threshold: 0 }).observe(m);
      }
      v.addEventListener('playing', function () { m.classList.add('is-playing'); });
      if (btn) btn.addEventListener('click', function () {
        if (v.paused) { delete v.dataset.stopped; play(); } else { v.dataset.stopped = '1'; v.pause(); }
        var p = !!v.dataset.stopped, lab = $('b', btn), ico = $('span', btn);
        btn.classList.toggle('is-paused', p);
        btn.setAttribute('aria-label', btn.getAttribute(p ? 'data-play' : 'data-pause') || '');
        if (lab) lab.textContent = btn.getAttribute(p ? 'data-l-play' : 'data-l-pause') || '';
        if (ico) ico.innerHTML = p
          ? '<svg class="e-ico" width="14" height="14" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M9 6.5v11l9-5.5z" fill="currentColor"/></svg>'
          : '<svg class="e-ico" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M9 6.5v11M15 6.5v11"/></svg>';
      });
    });
    tick();
  }
  function tick() {
    if (!ANIM) return;
    var vh = window.innerHeight;
    METS.forEach(function (m) {
      var big = m._big;
      if (!big || !document.body.contains(m)) return;
      var mr = m.getBoundingClientRect();
      if (mr.bottom < -200 || mr.top > vh + 200) return;
      var rs = big.parentNode, rw = big.closest('.e-met__r');
      if (mqDesk.matches && rw && getComputedStyle(rs).position === 'sticky') {
        var r = rw.getBoundingClientRect(), a = vh * 0.3, z = Math.max(1, (r.height - vh) - vh * 0.1);
        setBig(big, clamp((a - r.top) / (a + z)));
      } else {
        var b = big.getBoundingClientRect();
        setBig(big, clamp((vh * 0.72 - b.top) / (b.height + vh * 0.3)));
      }
    });
    LNS.forEach(function (L) {
      if (!L.w.offsetParent) return;
      var r = L.w.getBoundingClientRect();
      if (r.bottom < -300 || r.top > vh + 300) return;
      var dist = Math.max(r.height * 0.9, vh * 0.55);
      setLn(L, clamp((vh * (L.m ? 0.78 : 0.74) - r.top) / dist));
    });
  }
  var ticking = false;
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(function () { ticking = false; tick(); }); } }, { passive: true });
  window.addEventListener('resize', function () { LNS.forEach(placeIn); tick(); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { LNS.forEach(placeIn); });

  /* ---------------------------------------------------------------- regali: la riga si accende e a sinistra compare il suo gioiello */
  function initRegali(scope) {
    $$('[data-e-reg]', scope).forEach(function (sec) {
      if (sec._e) return;
      sec._e = true;
      var box = $('[data-e-reg-img]', sec), rows = $$('[data-e-reg-row]', sec);
      var show = function (r) {
        rows.forEach(function (x) { x.classList.toggle('is-on', x === r); });
        var i = r ? r.getAttribute('data-e-reg-row') : '-1';
        if (box) {
          var imgs = $$('img', box), hit = imgs.filter(function (im) { return im.getAttribute('data-i') === i; })[0];
          if (!hit && i === '-1') hit = imgs[0];
          if (hit) imgs.forEach(function (im) { im.classList.toggle('is-on', im === hit); });
        }
        if (r) redraw($('.e-segno', r));
      };
      rows.forEach(function (r) {
        r.addEventListener('mouseenter', function () { if (mqDesk.matches) show(r); });
        r.addEventListener('focus', function () { if (mqDesk.matches) show(r); });
      });
      var wrap = rows.length ? rows[0].parentNode : null;
      if (wrap) wrap.addEventListener('mouseleave', function () { show(null); });
      if (box && !$('img.is-on', box)) { var f = $('img', box); if (f) f.classList.add('is-on'); }
    });
  }

  /* ---------------------------------------------------------------- recensioni: i trattini seguono lo scorrimento (mobile) */
  function initRec(scope) {
    $$('[data-e-rec]', scope).forEach(function (t) {
      if (t._e) return;
      t._e = true;
      var dots = $$('i', t.parentNode.querySelector('.e-rec__dots') || document.createElement('div'));
      if (!dots.length) return;
      t.addEventListener('scroll', function () {
        var max = t.scrollWidth - t.clientWidth, i = max > 0 ? Math.round(t.scrollLeft / max * (dots.length - 1)) : 0;
        dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      }, { passive: true });
    });
  }

  /* ---------------------------------------------------------------- file che si trascinano con il mouse (Instagram) */
  function initDrag(scope) {
    $$('[data-e-drag]', scope).forEach(function (row) {
      if (row._e) return;
      row._e = true;
      var drag = false, sx = 0, s0 = 0, moved = false;
      row.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse' || e.button !== 0) return; drag = true; moved = false; sx = e.clientX; s0 = row.scrollLeft; row.style.scrollSnapType = 'none'; row.classList.add('is-grab'); });
      window.addEventListener('pointermove', function (e) { if (!drag) return; var dx = e.clientX - sx; if (Math.abs(dx) > 4) moved = true; row.scrollLeft = s0 - dx; });
      window.addEventListener('pointerup', function () { if (!drag) return; drag = false; row.classList.remove('is-grab'); row.style.scrollSnapType = ''; });
      row.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
      row.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });
  }

  /* ---------------------------------------------------------------- Instagram: i post dell'app (GSC Instagram Feed) nella fila Ellesanti.
     L'app scrive i post in window.GSC_INSTAFEED_MEDIA; se non ci sono, resta visibile il widget dell'app. */
  var ZW = new RegExp('[' + String.fromCharCode(0x2060, 0x200b, 0xfeff) + ']', 'g');
  function initIG(scope) {
    $$('[data-e-ig-feed]', scope).forEach(function (row) {
      if (row._ig) return;
      var sec = row.closest('.e-ig'), app = sec && $('.e-ig__app', sec);
      var feed = window.GSC_INSTAFEED_MEDIA, ids = [], items = [], seen = {};
      if (!app || !Array.isArray(feed)) return;
      $$('.gfa-widget', app).forEach(function (w) { Array.prototype.forEach.call(w.classList, function (c) { if (c.indexOf('GSC-') === 0) ids.push(c); }); });
      feed.forEach(function (f) { if (f && Array.isArray(f.data) && (!ids.length || ids.indexOf(f.id) > -1)) items = items.concat(f.data); });
      var max = +row.getAttribute('data-e-ig-feed') || 12, h = row.getAttribute('data-h') || '';
      items.forEach(function (m) {
        if (row.children.length >= max || !m || !m.permalink || seen[m.id]) return;
        var c0 = m.children && m.children.data ? m.children.data[0] : (Array.isArray(m.children) ? m.children[0] : null);
        var src = m.mediaType === 'VIDEO' ? m.thumbnailUrl : m.mediaUrl;
        if (!src && c0) src = c0.mediaType === 'VIDEO' ? c0.thumbnailUrl : c0.mediaUrl;
        if (!src) return;
        seen[m.id] = 1;
        var a = document.createElement('a'), img = document.createElement('img');
        a.className = 'e-ig__ph';
        a.href = m.permalink;
        a.target = '_blank';
        a.rel = 'noopener';
        if (h) { a.setAttribute('data-h', h); a.setAttribute('aria-label', 'Instagram ' + h); }
        img.src = src;
        img.loading = 'lazy';
        img.decoding = 'async';
        img.width = 600;
        img.height = 750;
        img.alt = (m.caption || '').split('\n')[0].replace(ZW, '').slice(0, 140);
        a.appendChild(img);
        row.appendChild(a);
      });
      if (!row.children.length) return;
      row._ig = true;
      row.hidden = false;
      app.classList.add('is-fed');
    });
  }

  function init(scope) {
    scope = scope || document;
    initIG(scope);
    initHero(scope);
    initMomenti(scope);
    initMetodo(scope);
    initRegali(scope);
    initRec(scope);
    initDrag(scope);
  }
  window.EllesantiV3 = window.EllesantiV3 || {};
  window.EllesantiV3.hooks = window.EllesantiV3.hooks || [];
  window.EllesantiV3.hooks.push(init);
  window.EllesantiV3.racconto = { tick: tick, setLn: setLn };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
})();
